import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"
import GenericModal from "src/v2/components/modal/generic-modal"
import CompanyFinancialSection from "./company-financial-section"

const CompanyFinancialModal = ({ open, onClose, financial }) => (
    <GenericModal
        isOpen={open}
        onClose={onClose}
        title="Indicadores Financeiros e Balanço Patrimonial"
        width="min(1180px, calc(100vw - 32px))"
        fullWidth
    >
        <Box sx={{ width: "100%", px: { xxxs: 2, sm: 3 } }}>
            <CompanyFinancialSection financial={financial} />
        </Box>
    </GenericModal>
)

CompanyFinancialModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    financial: PropTypes.object.isRequired,
}

export default CompanyFinancialModal
